import React, { useRef } from 'react';
import {
    Container,
    Flex,
    Box,
    Heading,
    Text,
    IconButton,
    Button,
    VStack,
    HStack,
    Wrap,
    WrapItem,
    FormControl,
    FormLabel,
    Input,
    InputGroup,
    InputLeftElement,
    Textarea,
  } from '@chakra-ui/react';
  import {
    MdPhone,
    MdEmail,
    MdLocationOn,
    MdFacebook,
    MdOutlineEmail,
  } from 'react-icons/md';
  import { BsGithub, BsDiscord, BsPerson, BsLinkedin} from 'react-icons/bs';
import emailjs from '@emailjs/browser';
import {AiFillTwitterSquare} from 'react-icons/ai';
import style from "./Newcontact.module.css"
  
  export default function Newcontact() {

    const handlegit = () => {
        window.open("https://github.com/Abhishekjha1996")
    }

    const handlelinkedin = () => {
        window.open("https://www.linkedin.com/in/abhishekjha96")
    }

    const handletwitter = () => {
      window.open("https://twitter.com/ajha6667")
  }

    
    
    const form = useRef();

    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs.sendForm('service_fxvhlxh', 'template_bczbjht', form.current, 'aV5J0ror-z4spScPI')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
    };
  

    return (
      <Container bg="black" maxW="full" mt={0} centerContent overflow="hidden" id="Newcontact" >
        <Flex>
          <Box
            bg="black"
            color="white"
            borderRadius="lg"
            m={{ sm: 4, md: 16, lg: 10 }}
            p={{ sm: 5, md: 5, lg: 16 }}>
            <Box p={4}>
              <Wrap spacing={{ base: 20, sm: 3, md: 5, lg: 20 }}>
                <WrapItem>
                  <Box>
                    <Heading>Contact</Heading>
                    <Text mt={{ sm: 3, md: 3, lg: 5 }} color="gray.500">
                      Fill up the form below to contact
                    </Text>
                    <Box py={{ base: 5, sm: 5, md: 8, lg: 10 }}>
                      <VStack pl={0} spacing={3} alignItems="flex-start">
                        <Button
                          size="md"
                          height="48px"
                          width="200px"
                          variant="ghost"
                          color="#DCE2FF"
                          _hover={{ border: '2px solid #1C6FEB' }}
                          leftIcon={<MdPhone color="#1970F1" size="20px" />}>
                          +91-8240443100
                        </Button>
                        <Button
                          size="md"
                          height="48px"
                          width="300px"
                          variant="ghost"
                          color="#DCE2FF"
                          _hover={{ border: '2px solid #1C6FEB' }}
                          leftIcon={<MdEmail color="#1970F1" size="20px" />}>
                          abhishek.jha001996@gmail.com
                        </Button>
                        <Button
                          size="md"
                          height="48px"
                          width="200px"
                          variant="ghost"
                          color="#DCE2FF"
                          _hover={{ border: '2px solid #1C6FEB' }}
                          leftIcon={<MdLocationOn color="#1970F1" size="20px" />}>
                          Kolkata, India
                        </Button>
                      </VStack>
                    </Box>
                    <HStack
                      mt={{ lg: 10, md: 10 }}
                      spacing={5}
                      px={5}
                      alignItems="flex-start">
                      <IconButton
                        aria-label="linkedin"
                        variant="ghost"
                        size="lg"
                        isRound={true}
                        _hover={{ bg: '#0D74FF' }}
                        icon={<BsLinkedin size="28px" />}
                        onClick={handlelinkedin}
                      />
                      <IconButton
                        aria-label="github"
                        variant="ghost"
                        size="lg"
                        isRound={true}
                        _hover={{ bg: '#0D74FF' }}
                        icon={<BsGithub size="28px" />}
                        onClick={handlegit}
                      />
                      <IconButton
                        aria-label="discord"
                        variant="ghost"
                        size="lg"
                        isRound={true}
                        _hover={{ bg: '#0D74FF' }}
                        icon={<AiFillTwitterSquare size="28px" />}
                        onClick={handletwitter}
                      />
                    </HStack>
                  </Box>
                </WrapItem>
                <WrapItem>
                  <Box bg="white" borderRadius="lg" width="450px">
                    <Box m={8} color="white">
                      <VStack spacing={5} >
                        <FormControl id="name"ref={form} onSubmit={sendEmail} >

                        <FormControl id="name">

                          <FormLabel>Your Name</FormLabel>
                          <InputGroup borderColor="#E0E1E7" width="90%" margin = "auto" height="50px">
                            
                            <Input type="text" size="md" name="user_name" />
                          </InputGroup >
                        </FormControl>
                        <FormControl id="name">
                          <FormLabel>Mail</FormLabel>
                          <InputGroup borderColor="#E0E1E7" width="90%" margin = "auto" height="50px">
                            
                            <Input type="text" size="md" name="user_email"/>
                          </InputGroup>
                        </FormControl>
                        <FormControl id="name">
                          <FormLabel>Message</FormLabel>
                          <Textarea
                            borderColor="gray.300"
                            _hover={{
                              borderRadius: 'gray.300',
                            }}
                            placeholder="message"
                            width="90%" margin = "auto" height="50px"
                            name="message"
                          />
                        </FormControl>
                        <FormControl id="name" float="right">
                          <Button
                            variant="solid"
                            bg="#0D74FF"
                            color="white"
                            _hover={{}}
                            value="Send">
                            Send Message
                          </Button>
                        </FormControl>
                        </FormControl>
                      </VStack>
                    </Box>
                  </Box>
                </WrapItem>
                
                {/* <WrapItem>
                  <div id={style.formdata}  >
                <form ref={form} onSubmit={sendEmail}>
                 <label>Name ::</label>
                <input type="text" name="user_name"  placeholder='Enter Name'/><br />
                <label>Email ::</label>
                <input type="email" name="user_email" placeholder='Enter Email' /><br />
                 <label>Message ::</label>
                <textarea name="message" /><br/>
                <input type="submit" value="Send" />
                </form>
                </div>
                </WrapItem> */}


              </Wrap>
            </Box>
          </Box>
        </Flex>
      </Container>
    );
  }